/* import __COLOCATED_TEMPLATE__ from './items-table.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from '@ember/service';
import Component from '@glimmer/component';
const DEFAULT_LOCALE = 'EN';
const DRAFT_STATUS = 'draft';
const INVOICE_MODAL = 'invoice-modal';
const INVOICE_FORM = 'invoice-form';
let ItemsTable = (_class = class ItemsTable extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get isInvoice() {
    return !this.args.isQuote && !this.args.isCreditNote;
  }
  get showSubtotalsVatRates() {
    return this.isInvoice && this.args.document?.displayEachVatSubtotals;
  }
  get shouldDisplayStampDutyDisclaimer() {
    return this.args.document.stampDutyAmount && this.args.document.stampDutyAmount !== '0.00';
  }
  get isDraftTitleDisplayed() {
    let {
      status
    } = this.args.document;
    let {
      origin
    } = this.args;
    return status === DRAFT_STATUS && !(origin === INVOICE_MODAL || origin === INVOICE_FORM);
  }
  get shouldDisplayDraftDisclaimer() {
    return this.args.document.organization?.legalCountry?.toUpperCase() === 'IT' && this.isDraftTitleDisplayed;
  }
  get totalsTableMarginBottomClass() {
    if (this.shouldDisplayStampDutyDisclaimer) return 'mb-8';
    if (this.shouldDisplayDraftDisclaimer) return 'mb-40';
    return 'mb-16';
  }
  get uppercaseLocale() {
    return this.args.document.organization?.legalCountry?.toUpperCase() ?? DEFAULT_LOCALE;
  }
  get withholdingTaxAmount() {
    let withholdingTaxAmount = Math.abs(this.args.document.withholdingTaxAmount);
    if (this.args.isCreditNote) {
      return withholdingTaxAmount;
    }
    return -withholdingTaxAmount;
  }
  get withholdingTaxLabel() {
    if (this.args.document.organization?.legalCountry === 'IT') {
      return this.intl.t('ui-kit.pdf-preview.withholding-tax', {
        language: this.args.displayLanguage
      });
    } else if (this.args.document.organization?.legalCountry === 'ES') {
      return this.intl.t('ui-kit.pdf-preview.es-withholding-tax', {
        language: this.args.displayLanguage,
        irpfRate: this.intl.formatNumber(-this.args.document?.withholdingTax?.rate, {
          style: 'percent',
          locale: this.args.displayLanguage,
          minimumFractionDigits: '0',
          maximumFractionDigits: '1'
        })
      });
    }
  }
  get currency() {
    return this.args.document.currency || 'EUR';
  }
  get discountLabel() {
    if (this.args.document?.discount?.type === 'absolute') {
      return this.intl.t('ui-kit.pdf-preview.amount-discount', {
        language: this.args.displayLanguage
      });
    } else {
      return this.intl.t('ui-kit.pdf-preview.total-discount', {
        language: this.args.displayLanguage,
        discountPercentage: this.intl.formatNumber(this.args.document?.discount?.value, {
          style: 'percent',
          locale: this.args.displayLanguage,
          minimumFractionDigits: '0',
          maximumFractionDigits: '1'
        })
      });
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ItemsTable as default };